import { motion } from 'framer-motion';
import {
  Building2,
  HardHat,
  Factory,
  Shirt,
  Flame,
  Zap,
  Droplets,
  Cpu,
  UtensilsCrossed,
} from 'lucide-react';
import { INDUSTRIES, IMAGES } from '../data/content';
import { SectionHeader } from '../components/SectionHeader';

const ICONS = {
  Building2,
  HardHat,
  Factory,
  Shirt,
  Flame,
  Zap,
  Droplets,
  Cpu,
  UtensilsCrossed,
};

const DESCRIPTIONS = {
  Infrastructure: 'Roads, railways, metro corridors and structural works.',
  Construction: 'Industrial civil construction and turnkey site execution.',
  'Industrial Manufacturing': 'Manufacturing plant erection, utility and process systems.',
  Textiles: 'End-to-end textile plant installation, ZLD and ETP.',
  'Oil & Gas': 'Process piping, cladding and welding automation for CRA industries.',
  Energy: 'Power, steam and utility infrastructure.',
  Utilities: 'Water, fire hydrant, ZLD/ETP and utility piping systems.',
  Technology: 'SaaS, applications and digital transformation by Zolvix Technologies.',
  Hospitality: 'Restaurants, cafés and consumer food brands.',
};

export default function Industries() {
  return (
    <div className="bg-white">
      <section className="relative pt-44 pb-20 bg-[#0D1B2A] grain overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: `url(${IMAGES.infra})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className="absolute inset-0 bg-[#0D1B2A]/82" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="overline text-white/80 flex items-center gap-3 mb-6">
            <span className="gold-rule" /> Industries Served
          </div>
          <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl leading-[1.05]">
            Engineering for the industries <span className="text-[#D4AF37]">that build economies.</span>
          </h1>
          <p className="mt-8 text-white/75 text-lg max-w-3xl leading-relaxed">
            From process industries to public infrastructure, we engineer outcomes that withstand
            scale, complexity and time.
          </p>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {INDUSTRIES.map((ind, i) => {
              const Icon = ICONS[ind.icon];
              return (
                <motion.div
                  key={ind.name}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-40px' }}
                  transition={{ duration: 0.5, delay: i * 0.04 }}
                  className="group bg-[#F5F7FA] border border-[#0D1B2A]/8 p-8 md:p-10 card-hover-lift"
                >
                  <div className="w-14 h-14 bg-white border border-[#D4AF37]/40 flex items-center justify-center group-hover:bg-[#0D1B2A] transition-colors">
                    <Icon
                      size={26}
                      className="text-[#0D1B2A] group-hover:text-[#D4AF37] transition-colors"
                    />
                  </div>
                  <h3 className="mt-6 font-display font-bold text-2xl text-[#0D1B2A]">
                    {ind.name}
                  </h3>
                  <p className="mt-3 text-[14px] text-[#4B5563] leading-relaxed">
                    {DESCRIPTIONS[ind.name]}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
